//@flow
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import ClientRoutesContainer from './ClientRoutesContainer';
import SessionIdleTimeoutContainer from 'container/components/SessionIdleTimeout';
import InitialDataFetcher from 'container/components/InitialDataFetcher';
import ClientIdSync from 'container/components/ClientIdSync';
import AppExternalServiceInitializer from 'container/components/AppExternalServiceInitializer';
import DataDateRangeTracker from 'container/components/DataDateRangeTracker';
import { ToastErrorBoundary, lazy } from 'common/modules/mfe';

import ClientConfigService from 'common/services/ClientConfigService';
import { usePlatformSettings } from 'common/modules/platform-settings';

import Favicon from './Favicon';

const AlertsToastContainer = lazy(
    () => import('platform-app/alerts/AlertsToastContainer'),
    {
        Fallback: () => null,
        ErrorBoundary: ({ children }) => {
            const { t } = useTranslation('alertNotifications');
            return (
                <ToastErrorBoundary
                    errorTitle={t('genericError')}
                    errorContent={t('errors.errorLoadingAlertsNotifications')}
                >
                    {children}
                </ToastErrorBoundary>
            );
        }
    }
);

const AlertsToastContainerWrap = () => {
    const settings = usePlatformSettings();

    return ClientConfigService.isAlertsEnabled() &&
        settings.alertsSettings.isAlertsEnabled ? (
        <AlertsToastContainer />
    ) : null;
};

const ClientRoutesContainerWrap = (): React.Node => {
    return (
        <ClientIdSync>
            <InitialDataFetcher>
                <AppExternalServiceInitializer>
                    <Favicon />
                    <SessionIdleTimeoutContainer />
                    <ClientRoutesContainer />
                    <AlertsToastContainerWrap />
                    <DataDateRangeTracker />
                </AppExternalServiceInitializer>
            </InitialDataFetcher>
        </ClientIdSync>
    );
};

export default ClientRoutesContainerWrap;
export { ClientRoutesContainerWrap };
